export { default } from './TarifCard';
